module.exports = __webpack_public_path__ + "img/2f55ab5.png";